import { Component, OnInit } from '@angular/core';
import { HomePageService } from './services/home-page.service';
import { Scenario } from './models/home-page.interface';
import { LoadingComponent } from '../../core/layout/components/loading/loading.component';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { HowToPlayService } from '../../shared/services/how-to-play.service';
import config from '../../../config.js';

@Component({
  selector: 'app-home-page',
  standalone: true,
  imports: [LoadingComponent, CommonModule],
  templateUrl: './home-page.component.html',
  styleUrl: './home-page.component.scss',
})
export class HomePageComponent implements OnInit {
  scenarios: Scenario[] = [];
  isLoading = true;

  constructor(
    readonly _homePageService: HomePageService,
    readonly router: Router,
    private howToPlayService: HowToPlayService
  ) {}

  ngOnInit(): void {
    console.log(config);
    this.getScenarios();
  }

  async getScenarios() {
    try {
      const getScenariosResponse = await this._homePageService.getScenarios();
      this.scenarios = getScenariosResponse.scenarios;
    } catch (error) {
      console.error('Error fetching scenarios:', error);
    } finally {
      this.isLoading = false;
    }
  }

  goToSimulator(scenarioId: string) {
    sessionStorage.setItem('scenarioId', scenarioId);
    this.router.navigate(['/scenario/prepare', scenarioId]);
  }

  transformText(text: string) {
    return text.replace(/\n/g, '<br>');
  }

  openHowToPlayGuide() {
    this.howToPlayService.openHowToPlayGuide();
  }
}
